import React from 'react'
import Header from '../components/header'

export default () => (
  <div>
    <Header color="red" />
    <div>Contact</div>
    <footer>Footer</footer>
  </div>
)